export default {
  methods: {
    calICH() {
      var risk = ['0%', '13%', '26%', '72%', '97%', '100%', '*100%'];
      var a = document.ICHForm.elements;
      var score = parseInt(a[0].value);

      for (var i = 1; i < 5; i++) {
        if (a[i].checked) {
          score += 1;
        }
      }

      document.getElementById('ICHscore').innerHTML = score;
      document.getElementById('ICHrisk').innerHTML = risk[score];
    }

  },
  id: '4abf789520',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=ICH><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a href=# class="link back"><i class="icon icon-back"></i> <span class=if-not-md>Back</span></a></div><div class=title>ICH Score</div></div></div><div class=page-content><form name=ICHForm><div class=list><ul><li><a class="item-link smart-select smart-select-init" data-open-in=sheet><select name=ICH1 @change=calICH><option value=0 selected=selected>13-15</option><option value=1>5-12</option><option value=2>3-4</option></select><div class=item-content><div class=item-inner><div class=item-title>GCS at time of transfer</div></div></div></a></li><li class=item-content><div class=item-inner><div class=item-title>Age &ge;80 years</div><label class="toggle toggle-init color-green"><input type=checkbox name=ICH2 @change=calICH> <span class=toggle-icon></span></label></div></li><li class=item-content><div class=item-inner><div class=item-title>Infratentorial origin</div><label class="toggle toggle-init color-green"><input type=checkbox name=ICH3 @change=calICH> <span class=toggle-icon></span></label></div></li><li class=item-content><div class=item-inner><div class=item-title>ICH volume &ge;30 cm<sup>3</sup></div><label class="toggle toggle-init color-green"><input type=checkbox name=ICH4 @change=calICH> <span class=toggle-icon></span></label></div></li><li><a class="item-content item-link" href=/ABC2/ ><div class=item-media></div><div class=item-inner><div class=item-title>Calculate volume</div><div class=item-after>ABC/2</div></div></a></li><li class=item-content><div class=item-inner><div class=item-title>Intraventricular hemorrhage</div><label class="toggle toggle-init color-green"><input type=checkbox name=ICH5 @change=calICH> <span class=toggle-icon></span></label></div></li></ul></div><div class="list simple-list"><ul><li><span>ICH Score:</span><div class=float-right><b><span id=ICHscore>0</span></b></div></li><li><span>30-day mortality:</span><div class=float-right><span id=ICHrisk>0%</span></div></li></ul></div></form></div></div>';
      return r;
    }(this);
  },

  styleScoped: false
};